import BasicModal from "../Modal/BasicModal";
import Box from "@mui/material/Box";
import Button from "../Button/Button";
import { Link } from "react-router-dom";
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import { isStringOfLength } from "@pheaa/channels-component-library";
import { styled } from "@mui/material/styles";
import useNavigateQSA from "../../utils/hooks/useNavigateQSA";
import { useTheme } from "@mui/material";
import {
	HELP_MODULE_FAQ,
	HELP_MODULE_FAQ_QID_KEY,
	HELP_MODULE_KEY,
	HELP_MODULE_MAIL_FAX,
	HELP_MODULE_PHONE
} from "../../config/common";
import HelpModuleFAQ, { HelpModuleFAQHeader } from "./HelpModuleFAQ";
import HelpModuleMailFax, { HelpModuleMailFaxHeader } from "./HelpModuleMailFax";
import HelpModulePhone, { HelpModulePhoneHeader } from "./HelpModulePhone";
const HELP_MODULES = [
	HELP_MODULE_FAQ,
	HELP_MODULE_PHONE,
	HELP_MODULE_MAIL_FAX
];

const HelpCategoryButton = styled(Link)(({ theme }) => ({
	alignItems: "center",
	backgroundColor: theme.palette.helpModule.button,
	borderRadius: 8,
	color: theme.palette.primary.contrastText,
	display: "flex",
	flexDirection: "column",
	fontSize: "3.6rem",
	height: 100,
	justifyContent: "center",
	textDecoration: "none",
	width: 100,
	"&:hover, &:focus": {
		textDecoration: "underline"
	}
}));

const HelpCategoryButtonActive = styled(HelpCategoryButton)(({ theme }) => ({
	backgroundColor: "transparent",
	border: "2px solid white"
}));

const HelpModuleHeader = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.helpModule.backgroundB,
	padding: 35,
	paddingTop: 80,
	position: "relative"
}));

const HelpModuleContent = styled(Box)(({ theme }) => ({
	padding: 35,
	position: "relative"
}));

const IconClose = props => {
	return (
		<SvgIcon fontSize="16px" viewBox="0 0 18 18" {...props}>
			<path d="M1 1L17 17M17 1L1 17" stroke="#F4F5F8" strokeWidth="2" strokeLinecap="round" />
		</SvgIcon>
	);
};

const IconFAQ = () => {
	return (
		<SvgIcon sx={{ fontSize: "3.6rem" }} viewBox="0 0 20 38">
			<path fill="none" d="M1 9.60343C1 6.312 3.4822 1 10.5283 1C17.5753 1 19 7.432 19 9.60343C19 11.7749 18.3358 14.2809 14.437 18.2416C10.5355 22.2023 10 24.2594 10 26.1429V28.4286" stroke="#F4F5F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<path fill="none" d="M9.57143 36.1429C10.9916 36.1429 12.1429 34.9916 12.1429 33.5714C12.1429 32.1513 10.9916 31 9.57143 31C8.15127 31 7 32.1513 7 33.5714C7 34.9916 8.15127 36.1429 9.57143 36.1429Z" stroke="#F4F5F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		</SvgIcon>
	);
};

const IconCall = () => {
	return (
		<SvgIcon sx={{ fontSize: "3.8rem" }} viewBox="0 0 40 40">
			<path fill="none" d="M37.0786 29.4921L30.4843 25.1818C29.1108 24.3118 27.2959 24.6747 26.3628 26.0058C24.8411 27.844 23.0022 30.8866 16.0909 23.9774C9.17951 17.0683 12.1596 15.1667 13.9984 13.6455C15.33 12.7127 15.693 10.8984 14.8227 9.52536L10.5111 2.93318C9.9404 2.10916 9.17951 0.778046 7.40411 1.03159C5.62872 1.28514 1 3.88398 1 9.58875C1 15.2935 5.5019 22.266 11.6524 28.4145C17.8029 34.563 24.7776 39 30.4209 39C36.0641 39 38.7906 33.9291 38.9808 32.6614C39.171 31.3936 37.9029 30.0625 37.0786 29.4921Z" stroke="#F4F5F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		</SvgIcon>

	);
};

const IconMailFax = () => {
	return (
		<SvgIcon sx={{ fontSize: "4.1rem" }} viewBox="0 0 41 40">
			<path fill="none" d="M17 23.5V38.3889L24 28" stroke="#F4F5F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<path fill="none" d="M39 1L16.8472 23.6216M1 17.5L40 1L33.7321 34L17.0179 23.6875L1 17.5Z" stroke="#F4F5F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		</SvgIcon>
	);
};

const getRandomInteger = (min, max) => {
	return Math.floor(Math.random() * (max - min + 1) + min);
};

const HelpManager = props => {

	const queryParams = new URLSearchParams(window.location.search);
	const navigate = useNavigateQSA();
	const theme = useTheme();
	const [headerRibbonIndex] = React.useState(getRandomInteger(1, 3));

	const helpModuleStyles = {
		animation: "help-module-enter ease-out 0.35s",
		backgroundColor: theme.palette.helpModule.backgroundA,
		borderRadius: 0,
		bottom: 0,
		boxShadow: theme.shadows[12],
		color: theme.palette.primary.contrastText,
		left: "auto",
		minWidth: 375,
		overflowX: "auto",
		padding: 0,
		right: 0,
		top: 0,
		transform: 0,
		width: "min(100vw, var(--help-module-width))"
	};

	const handleClose = e => {
		navigate({ search: { [HELP_MODULE_KEY]: null, [HELP_MODULE_FAQ_QID_KEY]: null } });
	};

	const handleToggleModule = (e, moduleKey) => {
		e.preventDefault();
		navigate({ search: { [HELP_MODULE_KEY]: moduleKey, [HELP_MODULE_FAQ_QID_KEY]: null } });
	};

	const helpModule = queryParams.get(HELP_MODULE_KEY);
	const isHelpModuleActive = isStringOfLength(helpModule) && HELP_MODULES.includes(helpModule.toLowerCase());

	return (
		<BasicModal open={isHelpModuleActive} style={helpModuleStyles} styleBackdropProps={{ invisible: true }}>
			<div className="cmp-help-module__ribbon" data-index={headerRibbonIndex} />
			<HelpModuleHeader sx={{ paddingTop: { xs: 10, md: 4.375 }, paddingX: { xs: 1, sm: 4.375 } }}>
				<Button
					onClick={handleClose}
					sx={{
						alignItems: "center",
						display: "flex",
						flexDirection: "column",
						inset: "20px 20px auto auto",
						position: "absolute"
					}}
					variant="text"
				>
					<IconClose sx={{ mb: 0.5 }} />
					<Typography
						sx={{
							color: theme.palette.primary.contrastText,
							fontFamily: theme.typography.fontFamily,
							fontSize: 12,
							fontWeight: 400,
							textTransform: "none"
						}}
					>
						Close <span className="a11y-hidden">Help Module</span>
					</Typography>

				</Button>
				<Box className="cmp-help-module__nav" component="nav" sx={{ mb: 4.5 }}>
					<Box />
					{
						HELP_MODULES.map((moduleKey, i) => {
							let moduleIconElem = null;
							let moduleTitle = null;
							const HelpCategoryElem = helpModule === moduleKey ? HelpCategoryButtonActive : HelpCategoryButton;

							if (moduleKey === HELP_MODULE_FAQ) {
								moduleIconElem = <IconFAQ />;
								moduleTitle = "FAQ";
							} else if (moduleKey === HELP_MODULE_PHONE) {
								moduleIconElem = <IconCall />;
								moduleTitle = "Call";
							} else if (moduleKey === HELP_MODULE_MAIL_FAX) {
								moduleIconElem = <IconMailFax />;
								moduleTitle = "Mail or Fax";
							}

							return (
								<Box key={i}>
									<HelpCategoryElem onClick={e => handleToggleModule(e, moduleKey)} value={moduleKey}>
										{moduleIconElem}
										<Typography
											fontSize="1.4rem"
											fontWeight={700}
											sx={{ mt: 1 }}
											textTransform="uppercase"
										>
											{moduleTitle}
										</Typography>
									</HelpCategoryElem>
								</Box>
							);
						})
					}
					<Box />
				</Box>
				<Box>
					{
						HELP_MODULES.map((moduleKey, i) => {
							let HelpModuleHeaderContent = null;

							if (moduleKey === HELP_MODULE_FAQ) {
								HelpModuleHeaderContent = HelpModuleFAQHeader;
							} else if (moduleKey === HELP_MODULE_PHONE) {
								HelpModuleHeaderContent = HelpModulePhoneHeader;
							} else if (moduleKey === HELP_MODULE_MAIL_FAX) {
								HelpModuleHeaderContent = HelpModuleMailFaxHeader;
							}

							return helpModule === moduleKey && HelpModuleHeaderContent && (
								<HelpModuleHeaderContent key={i} />
							);
						})
					}
				</Box>
			</HelpModuleHeader>
			<HelpModuleContent sx={{ paddingX: { xs: 1, sm: 4.375 } }}>
				{
					HELP_MODULES.map((moduleKey, i) => {
						let HelpModuleContent = null;

						if (moduleKey === HELP_MODULE_FAQ) {
							HelpModuleContent = HelpModuleFAQ;
						} else if (moduleKey === HELP_MODULE_PHONE) {
							HelpModuleContent = HelpModulePhone;
						} else if (moduleKey === HELP_MODULE_MAIL_FAX) {
							HelpModuleContent = HelpModuleMailFax;
						}

						return helpModule === moduleKey && HelpModuleContent && (
							<HelpModuleContent key={i} />
						);
					})
				}
			</HelpModuleContent>
		</BasicModal>
	);
};

export default HelpManager;